module.exports = __webpack_public_path__ + "ad65bc09cc28ac0f378a5c68e7885eac.png";